// A lizard, modelled facing +X: a low sandy body, a long tapering tail, a flat
// head and splayed legs. Ported 1:1 from age-of-mcp's classic lizard.ts,
// restoring its body/tail/head core and the splayed-leg double loop.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  const parts: Part[] = [
    { geometry: new THREE.IcosahedronGeometry(0.018, 0), color: "#a89248",
      position: [0, 0.012, 0], scale: [1.8, 0.7, 0.9] },             // body
    { geometry: new THREE.ConeGeometry(0.014, 0.05, 4), color: "#9a8540",
      position: [-0.05, 0.01, 0], rotation: [0, 0, Math.PI / 2] },     // tail
    { geometry: new THREE.IcosahedronGeometry(0.012, 0), color: "#b09a4e",
      position: [0.032, 0.013, 0], scale: [1.3, 0.7, 1] },           // head
  ];
  for (const side of [1, -1]) {
    for (const lx of [0.018, -0.014]) {
      parts.push({ geometry: new THREE.CylinderGeometry(0.002, 0.002, 0.022, 3),
        color: "#8a7638", position: [lx, 0.006, side * 0.016],
        rotation: [side * 1.0, 0, 0] });
    }
  }
  return parts;
}

export const lizard = defineModel({
  id: "lizard",
  batchId: "standard",
  name: "Lizard",
  tags: ["creature","lizard","low-poly","age-of-mcp","classic"],
  summary: "Low-poly lizard.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.06,
  parts: () => partsFor(),
  animations: [],
});
